import React from 'react';
import { MdExpandMore } from 'react-icons/md';
import MenuItem from './MenuItem';
import styles from './SideBar.module.css';

const NavSection = ({
    isOpen,
    sectionKey,
    sectionLabel,
    sectionSubtext,
    menuItems,
    isExpanded,
    onToggle,
    onNavClick
}) => {
    return (
        <div className={styles.navSection}>
            {isOpen && (
                <button
                    className={styles.sectionHeader}
                    onClick={() => onToggle(sectionKey)}
                >
                    <div className={styles.sectionHeaderContent}>
                        <div>
                            <span className={styles.sectionLabel}>{sectionLabel}</span>
                            <span className={styles.sectionSubtext}>{sectionSubtext}</span>
                        </div>
                        <MdExpandMore
                            className={`${styles.sectionExpandIcon} ${isExpanded ? styles.expanded : ''}`}
                        />
                    </div>
                </button>
            )}
            {isExpanded && (
                <div className={styles.menuItems}>
                    {menuItems.map((item, index) => (
                        <MenuItem
                            key={index}
                            item={item}
                            isOpen={isOpen}
                            onClick={onNavClick}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default NavSection;